<div class="flexColumnParent">
    <div class="logo flexItemBiggest">
        <logo-display></logo-display>
    </div>
</div>
